import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
// import LanguageDetector from 'i18next-browser-languagedetector';

import { isOrthodoxMode } from "./utils/featureFlags";

const languages = ["en", "he"];
const savedlanguage = localStorage.getItem("language");

function deepMerge(base: Record<string, any>, overrides: Record<string, any>): Record<string, any> {
  const result = { ...base };
  for (const key of Object.keys(overrides)) {
    if (typeof overrides[key] === 'object' && overrides[key] !== null && !Array.isArray(overrides[key])) {
      result[key] = deepMerge(base[key] ?? {}, overrides[key]);
    } else {
      result[key] = overrides[key];
    }
  }
  return result;
}

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedlanguage || "he",
    fallbackLng: "he",
    debug: false,
    whitelist: languages,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: `/locales/{{lng}}/translation.json`,
    },
  });

if (isOrthodoxMode) {
  i18n.on("loaded", () => {
    fetch("/locales/he/translation.orthodox.overrides.json")
      .then((r) => r.json())
      .then((overrides) => {
        const base = i18n.getResourceBundle("he", "translation");
        const merged = deepMerge(base, overrides);
        i18n.addResourceBundle("he", "translation", merged, true, true);
        i18n.changeLanguage(i18n.language);
      });
  });
}

export default i18n;
